import React, { forwardRef } from 'react';

import ItemListingCounter from './ItemListingCounter';
import ItemListingDefault from './ItemListingDefault';
import ItemListingLoadMore from './ItemListingLoadMore';
import ItemListingRails from './ItemListingRails';
import { ItemListingCarouselProps, ItemListingProps } from './models';

const ItemListing = forwardRef<
  HTMLDivElement,
  ItemListingProps | ItemListingCarouselProps
>((itemListing, ref) => {
  // eslint-disable-next-line react/destructuring-assignment
  const type = 'type' in itemListing && itemListing.type;

  switch (type) {
    case 'numbered':
      return (
        <ItemListingCounter ref={ref} {...(itemListing as ItemListingProps)} />
      );
    case 'loadMore':
      return (
        <ItemListingLoadMore ref={ref} {...(itemListing as ItemListingProps)} />
      );
    case 'default':
      return (
        <ItemListingDefault ref={ref} {...(itemListing as ItemListingProps)} />
      );

    default:
      return (
        <ItemListingRails
          ref={ref}
          {...(itemListing as ItemListingCarouselProps)}
        />
      );
  }
});

export default ItemListing;
